//Rem根fontzie大小
function setRem() {
  const baseSize = 100;
  const scale = document.documentElement.clientWidth / 750;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}
setRem();
window.addEventListener('resize', setRem)